import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ModelViewComponent } from './model-view/model-view.component';
import { StepContainerComponent } from './step-container/step-container.component';
import { StepOneComponent } from './steps/step-one/step-one.component';
import { StepTwoComponent } from './steps/step-two/step-two.component';
import { StepThreeComponent } from './steps/step-three/step-three.component';
import { StepFourComponent } from './steps/step-four/step-four.component';
import { StepFiveComponent } from './steps/step-five/step-five.component';
import { StepSixComponent } from './steps/step-six/step-six.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { ProgressbarComponent } from './shared/progressbar/progressbar.component';
import { HelpComponent } from './shared/help/help.component';
import { CloseComponent } from './shared/close/close.component';
import { WatermarkComponent } from './shared/watermark/watermark.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { HelpstepComponent } from './steps/helpstep/helpstep.component';
import { IsomastersUiModule } from './shared/isomasters-ui/isomasters-ui.module';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localeNl from '@angular/common/locales/nl';
import localeDe from '@angular/common/locales/de';
import localeDa from '@angular/common/locales/da';
import localePl from '@angular/common/locales/pl';

import { DatePipe, registerLocaleData } from '@angular/common';
import { PriceInformationComponent } from './price-information/price-information.component';
import { StepThreeSliderComponent } from './steps/step-three/step-three-slider/step-three-slider.component';
import { InternalExternalSwitchComponent } from './shared/internal-external-switch/internal-external-switch.component';
import { SummaryComponent } from './summary/summary.component';
import { SummaryDialogComponent } from './shared/summary-dialog/summary-dialog.component';
import { ErrorComponent } from './shared/error/error.component';
import { ConfiguratorComponent } from './configurator/configurator.component';
import { NotificationComponent } from './shared/notification/notification.component';
import { StepFiveSliderComponent } from './steps/step-five/step-five-slider/step-five-slider.component';
import { IsomastersLogoComponent } from './shared/isomasters-logo/isomasters-logo.component';
import { environment } from 'src/environments/environment';
import { StepButtonsComponent } from './steps/step-buttons/step-buttons.component';
import { SummaryPriceListComponent } from './summary-price-list/summary-price-list.component';
import { SummaryContainerComponent } from './summary-container/summary-container.component';
import { SummaryStepComponent } from './summary-step/summary-step.component';
import { BalloonNotificationComponent } from './shared/notification/balloon-notification/balloon-notification.component';
import { InputAlternativesComponent } from './shared/notification/input-alternatives/input-alternatives.component';
import { DoorDimensionSliderComponent } from './steps/step-five/door-dimension-slider/door-dimension-slider.component';
import { PlusMinPricePipeModule } from './shared/pipes/plus-min-price-pipe.module';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { StepInnerWallsComponent } from './steps/step-inner-walls/step-inner-walls.component';
import { SummaryCollisionsComponent } from './summary-collisions/summary-collisions.component';
import { IsomasterRedLoadingComponent } from './shared/isomaster-red-loading/isomaster-red-loading.component';
import { LoadConfigurationComponent } from './load-configuration/load-configuration.component';
import { LoadingComponent } from './loading/loading.component';
import { SummaryShareDemoComponent } from './summary-share-demo/summary-share-demo.component';
import { LoadingIndicatorComponent } from './loading-indicator/loading-indicator.component';
import { ConflictsPanelComponent } from './conflicts-panel/conflicts-panel.component';
import { ReplacePipe } from './pipes/replace.pipe';
import { LazyTranslateLoader } from './lazy-translate-loader';

registerLocaleData(localeNl, 'nl');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeDa, 'da');
registerLocaleData(localePl, 'pl');

@NgModule({
  declarations: [
    AppComponent,
    ModelViewComponent,
    StepContainerComponent,
    StepOneComponent,
    StepTwoComponent,
    StepThreeComponent,
    StepFourComponent,
    StepFiveComponent,
    StepSixComponent,
    LanguageSelectorComponent,
    ProgressbarComponent,
    HelpComponent,
    CloseComponent,
    WatermarkComponent,
    HelpstepComponent,
    PriceInformationComponent,
    StepThreeSliderComponent,
    InternalExternalSwitchComponent,
    SummaryComponent,
    SummaryDialogComponent,
    ErrorComponent,
    ConfiguratorComponent,
    NotificationComponent,
    StepFiveSliderComponent,
    IsomastersLogoComponent,
    StepButtonsComponent,
    SummaryPriceListComponent,
    SummaryContainerComponent,
    SummaryStepComponent,
    BalloonNotificationComponent,
    InputAlternativesComponent,
    DoorDimensionSliderComponent,
    StepInnerWallsComponent,
    SummaryCollisionsComponent,
    IsomasterRedLoadingComponent,
    LoadConfigurationComponent,
    LoadingComponent,
    SummaryShareDemoComponent,
    LoadingIndicatorComponent,
    ConflictsPanelComponent,
    ReplacePipe,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FlexLayoutModule,
    HttpClientModule,
    NgxGoogleAnalyticsModule.forRoot(environment.googleAnalyticsTrackingCode),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: LazyTranslateLoader,
      },
    }),
    InlineSVGModule.forRoot(),
    IsomastersUiModule,
    PlusMinPricePipeModule,
  ],
  providers: [HttpClient, DatePipe],
  bootstrap: [AppComponent],
})
export class AppModule {}
